import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { IpdFeatureService } from '../services/ipd-feature.service';

export const ipdFeatureGuard: CanActivateFn = () => {
  const ipdFeature = inject(IpdFeatureService);
  const router = inject(Router);

  if (ipdFeature.isEnabled) {
    return true;
  }

  router.navigate(['/patient']);
  return false;
};
